import React from 'react';
import './WhyChoose.css';
import slide2 from '../why1.jpeg';
import slide3 from '../why2.jpeg';
import slide4 from '../why3.jpeg';
import slide5 from '../why4.jpeg';
import slide6 from '../why5.jpeg';

const WhyChoose = () => {
  return (
    <section className="why-choose-section">
      <div className="container">
        <div className="why-choose-header">
          <div className="why-choose-line"></div>
          <h2 className="why-choose-title">Why Choose Us</h2>
          <p className="why-choose-subtitle">
            Sri Veda Gurukulam stands as a trusted center for authentic Vedic education, guided by tradition, discipline, and spiritual integrity.
          </p>
        </div>
        
        <div className="why-choose-content">
          <div className="feature-card">
            <div className="card-image">
              <img src={slide2} alt="Authentic Gurukul System" />
            </div>
            <div className="card-content">
              <h3 className="card-title">Authentic Gurukul System</h3>
              <p className="card-description">
                Sri Veda Gurukulam follows the original Gurukul model where 
                education is life-centric, not classroom-centric. Students live in 
                close association with their Gurus, learning through daily discipline, 
                observation, oral transmission, and constant practice. This system 
                ensures purity of Vedic chanting, accuracy of rituals, and deep 
                internalization of spiritual values that cannot be achieved through 
                modern institutional teaching methods.
              </p>
            </div>
          </div>
          
          <div className="feature-card reverse">
            <div className="card-content">
              <h3 className="card-title">Lineage-Based Experienced Acharyas</h3>
              <p className="card-description">
                Teaching at Sri Veda Gurukulam is carried forward by Acharyas 
                trained in authentic Vedic lineages. Their knowledge is not 
                theoretical alone but rooted in lifelong practice of Vedas, Yagya, 
                Samskaras, and spiritual discipline. This ensures that students 
                receive knowledge exactly as preserved through generations, 
                without dilution or deviation.
              </p>
            </div>
            <div className="card-image">
              <img src={slide3} alt="Lineage-Based Experienced Acharyas" />
            </div>
          </div>
          
          <div className="feature-card">
            <div className="card-image">
              <img src={slide4} alt="Structured Yet Traditional Vedic Curriculum" />
            </div>
            <div className="card-content">
              <h3 className="card-title">Structured Yet Traditional Vedic Curriculum</h3>
              <p className="card-description">
                The Gurukulam provides a well-structured curriculum that covers 
                Vedas, Upavadas, Sanskrit grammar, chanting traditions, ritual 
                science, and Samskaras. Learning progresses systematically, 
                respecting each student's capacity while maintaining rigorous 
                standards. Practical training and repetition ensure mastery, 
                confidence, and spiritual depth.
              </p>
            </div>
          </div>
          
          <div className="feature-card reverse">
            <div className="card-content">
              <h3 className="card-title">Spiritual Discipline as a Way of Life</h3>
              <p className="card-description">
                At Sri Veda Gurukulam, spirituality is lived daily. From early morning 
                rituals to disciplined routines, students are trained to integrate 
                prayer, self-control, service, and humility into everyday life. This 
                creates strong character, mental clarity, and unwavering devotion, 
                forming individuals who live by Dharma naturally.
              </p>
            </div>
            <div className="card-image">
              <img src={slide5} alt="Spiritual Discipline as a Way of Life" />
            </div>
          </div>
          
          <div className="feature-card">
            <div className="card-image">
              <img src={slide6} alt="Legacy of Trust, Service, and National Contribution" />
            </div>
            <div className="card-content">
              <h3 className="card-title">Legacy of Trust, Service, and National Contribution</h3>
              <p className="card-description">
                Established in 1987, Sri Veda Gurukulam stands on decades of 
                unwavering commitment to Sanatana Dharma. The institution has 
                played a significant role in Vedic education, Yagya traditions, and 
                national spiritual initiatives. Its long-standing service has earned 
                trust, respect, and recognition across regions and generations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;